(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-modal"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-modal"], factory);
	else if(typeof exports === 'object')
		exports["ReactImageLightbox"] = factory(require("react"), require("react-modal"));
	else
		root["ReactImageLightbox"] = factory(root["react"], root["react-modal"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_72__, __WEBPACK_EXTERNAL_MODULE_73__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition